export var IconsManifest = [
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "csg",
    "name": "Costar Cosmos icons",
    "projectUrl": "",
    "license": "",
    "licenseUrl": ""
  }
]